import React from 'react'
import { Menu, Pagination, Card, Empty } from 'antd'
import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'

import * as styles from '../index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}
export default class ListRender extends ComponentExt<IProps, IState> {
  state = {
    selectKeys: ['news'],
  }

  async componentDidMount() {
    const key = this.handleGetSearchParams('listType')
    const labelId = this.handleGetSearchParams('labelId')
    if (key) {
      this.setState({
        selectKeys: [key],
        labelId,
      })
    } else {
      this.setState({
        selectKeys: ['news'],
        labelId,
      })
    }
  }

  handleGetSearchParams = type => {
    const { that }: any = this.props
    return new URLSearchParams(that.props.location.search).get(type)
  }

  handleClick = e => {
    const { handleClickMenu }: any = this.props
    // console.log('e', e)
    this.setState({ selectKeys: [e.key] }, () => handleClickMenu(e))
  }

  render() {
    const {
      that,
      listLen,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
    }: any = this.props
    const {
      state: { selectKeys, labelId },
      handleClick,
    }: any = this
    return (
      <>
        <div className={styles.contentLfBox}>
          <div className={styles.lfMenu}>
            <Menu
              onClick={handleClick}
              mode="horizontal"
              theme="light"
              selectedKeys={selectKeys || ['news']}
            >
              <Menu.Item key="news">
                <span>最新</span>
              </Menu.Item>
              <Menu.Item key="1000101">
                <span>视频</span>
              </Menu.Item>
              <Menu.Item key="1000102">
                <span>文章</span>
              </Menu.Item>
            </Menu>
          </div>
          <div className={styles.lfList}>
            <ul>
              {handleRenderList() || (
                <Card>
                  <Empty description="暂无数据" />
                </Card>
              )}
            </ul>
          </div>
          <Pagination
            onChange={async (p, s) =>
              that.handleFetchArticleList({
                label_type: 1,
                page: p,
                label_id: labelId,
              })
            }
            defaultCurrent={1}
            pageSize={6}
            total={listLen || 1}
          />
        </div>
        <div className={styles.contentRtBox}>
          <Card title="全部标签">{handleRenderTag()}</Card>
          <Card className={styles.recommend} title="推荐">
            <ul>{handleRenderRecommend()}</ul>
          </Card>
        </div>
      </>
    )
  }
}
